import {FeatureToggle, isFeatureEnabled} from '@/helpers/featureToggle'
import {cn} from '@/helpers/shadcn/utils'
import {ComponentPropsWithoutRef} from 'react'
import {SingleImageUploadControl, ImageUploadChangeValue} from '@/components/SingleImageUpload'
import {FieldLabel} from '@/shared-components/FieldLabel'
import {useCountries} from '@/hooks/useCountries'

export type CustomImageSelectorProps = Omit<ComponentPropsWithoutRef<'div'>, 'onChange'> & {
  label: string
  value?: string
  disabled?: boolean
  required?: boolean
  onChange: (newValue: ImageUploadChangeValue) => void
}

export const CustomImageSelector = ({
  label,
  value,
  onChange,
  className,
  disabled,
  required,
  ...props
}: CustomImageSelectorProps) => {
  const {country} = useCountries()

  if (!isFeatureEnabled(FeatureToggle.sendPushCustomImage)) {
    return null
  }

  return (
    <div data-testid="custom-image" className={cn('flex gap-4', className)} {...props}>
      <div className="flex w-full min-w-fit flex-col gap-2">
        <FieldLabel id={props.id} label={label} required={required} disabled={disabled} />
        <SingleImageUploadControl
          value={value}
          onChange={onChange}
          required={required}
          description="Select or drag and drop your image"
          galleryTag={`CCT-${country}`}
        />
      </div>
    </div>
  )
}
